import { Moon, Sun } from "lucide-react";
import { useTheme } from "@/context/ThemeContext";

export const ThemeToggle = ({ className = "", label = false, testId = "theme-toggle" }) => {
  const { mode, toggle } = useTheme();
  const dark = mode === "dark";
  return (
    <button
      type="button"
      onClick={toggle}
      data-testid={testId}
      aria-label={dark ? "Switch to light mode" : "Switch to dark mode"}
      title={dark ? "Switch to light mode" : "Switch to dark mode"}
      className={`inline-flex items-center gap-2 rounded-md border border-slate-600/60 px-2.5 py-1.5 text-xs text-slate-300 transition-colors hover:bg-slate-700/60 hover:text-white ${className}`}
    >
      {dark ? <Sun className="h-3.5 w-3.5" /> : <Moon className="h-3.5 w-3.5" />}
      {label && <span data-testid={`${testId}-label`}>{dark ? "Light mode" : "Dark mode"}</span>}
    </button>
  );
};
